import * as React from "react";
import { Caregiver, CaregiverCertification } from "../../messages";
import "./CaregiverInfo.css";
import { formatPhone } from "../../phone_number";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "src/store/store";
import { setCertificationActionCreator } from "src/store/slices/certificationsSlice";
import { useCallback } from "react";

interface CaregiverInfoProps {
    caregiver: Caregiver;
    photoUrl: string | null;
    caregiverCertifications: CaregiverCertification[];
    onCertificationChange: (certification: CaregiverCertification) => void;
}

const CaregiverInfo = (props: CaregiverInfoProps) => {
    const certifications = useSelector((state: AppState) => state.certifications);
    const dispatch = useDispatch();

    const handleCertificationChange = useCallback((event: any) => {
        const certification = CaregiverCertification.wrap(event.target.value);
        dispatch(setCertificationActionCreator(certification));
        props.onCertificationChange(certification);
    }, []);

    return (
        <div className="CaregiverInfo__main">
            <div className={"CaregiverInfo__photoContainer"}>
                {props.photoUrl !== null || props.caregiver.photoUrl !== null ?
                    <div
                        style={{
                            background: `url(${props.photoUrl !== null ? props.photoUrl : props.caregiver.photoUrl}) center / cover`
                        }}
                        className={"CaregiverInfo__photo"}
                    />
                    : null}
            </div>
            <h3 className={"CaregiverInfo__header"}>{props.caregiver.firstName + " " + props.caregiver.lastName}</h3>
            <div className="d-flex justify-content-center align-items-center">
                <span className="Globals__marginRightLarge">
                    <strong>Address: </strong>
                    {props.caregiver.address}
                </span>
                <span className="Globals__marginRightLarge">
                    <strong>Phone Numbers: </strong>
                    {props.caregiver.phoneNumbers.map((pnumber) => formatPhone(pnumber.phoneNumber)).join(", ")}
                </span>
                <span className="Globals__marginRightLarge d-flex align-items-center">
                    <strong className="mr-2">Certification: </strong>
                    {certifications.selectedCertification === null ? null : (
                        <li className="nav-item mx-0 mx-lg-1 d-flex align-items-center">
                            <select
                                className="form-control"
                                value={CaregiverCertification.unwrap(certifications.selectedCertification)}
                                onChange={handleCertificationChange}
                            >
                                {certifications.agencyCertifications.map((certification: CaregiverCertification) => {
                                    return (
                                        <option
                                            key={CaregiverCertification.unwrap(certification)}
                                            value={CaregiverCertification.unwrap(certification)}
                                        >
                                            {CaregiverCertification.unwrap(certification)}
                                            {props.caregiverCertifications.length > 1 && props.caregiverCertifications.includes(certification) ? " (in progress)" : null}
                                        </option>
                                    );
                                })}
                            </select>
                        </li>
                    )}
                </span>
            </div>
        </div>
    );
};

export default CaregiverInfo;



// WEBPACK FOOTER //
// ./src/components/widgets/CaregiverInfo.tsx